export default (state) => {
    return state.userManagement;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/userManagementState.ts